import React from 'react';

const CampaignPrePostText = ({ campaign, vacancy, isPreCampaign, isEndCampaign, isCampaign=true }) => {
    const renderCampaignPrePostText = () => {
        const buildDate = (dateStr, timeStr) => {
            if (!dateStr) return null;
            const safeTime = timeStr && timeStr.length > 0 ? timeStr : "00:00";
            // Use ISO 8601 to ensure consistent parsing across browsers
            const isoString = `${dateStr}T${safeTime}`;
            const d = new Date(isoString);
            return isNaN(d.getTime()) ? null : d;
        };

        const startDate = isCampaign
            ? buildDate(campaign?.start_date, campaign?.start_time)
            : buildDate(vacancy?.start_date, vacancy?.start_time);
        const endDate = isCampaign
            ? buildDate(campaign?.end_date, campaign?.end_time)
            : buildDate(vacancy?.end_date, vacancy?.end_time);

        const messages = {
            pre_campaign_text: campaign?.pre_campaign_text || "Thank you for your interest! This campaign has not started yet. Please check back later.",
            end_campaign_text: campaign?.end_campaign_text || "Thank you for your interest. This campaign has ended.",
            pre_vacancy_text: vacancy?.pre_vacancy_text || campaign?.pre_campaign_text || "This position isn't open yet. Check back soon!",
            end_vacancy_text: vacancy?.end_vacancy_text || campaign?.end_campaign_text || "This position is no longer open. Check back soon for new opportunities!",
            pre_campaign_title: campaign?.pre_text_title || "Campaign Not Started",
            post_campaign_title: campaign?.post_text_title || "Campaign Ended",
            pre_vacancy_title: vacancy?.pre_text_title || campaign?.pre_text_title || "Position Not Started",
            post_vacancy_title: vacancy?.post_text_title || campaign?.post_text_title || "Position Closed",
        }
        
        // Adjust dates for timezone
        const timeZone = isCampaign ? campaign?.time_zone : vacancy?.time_zone;
        if (timeZone) {
            const tzOffset = parseInt((timeZone || "").split(' ')[1]);
            if (!isNaN(tzOffset)) {
                if (startDate) startDate.setHours(startDate.getHours() + tzOffset);
                if (endDate) endDate.setHours(endDate.getHours() + tzOffset);
            }
        }

        if (isPreCampaign) {
            return (
            <div className="w-full mx-auto p-8 text-center">
                <div className="max-w-2xl mx-auto bg-card rounded-xl shadow-lg p-8">
                <h2 className="text-2xl font-bold text-foreground mb-4">{isCampaign ? messages.pre_campaign_title : messages.pre_vacancy_title}</h2>
                <p className="text-muted-foreground text-lg">
                    {isCampaign ? messages.pre_campaign_text : messages.pre_vacancy_text}
                </p>
                {startDate && (
                <p className="text-sm text-muted-foreground mt-4">
                    {isCampaign ? "Campaign starts: " : "Position opens: "} {startDate.toLocaleString(undefined, { 
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                    })}
                </p>
                )}
                </div>
            </div>
            );
        }

        if (isEndCampaign) {
            return (
            <div className="w-full mx-auto p-8 text-center">
                <div className="max-w-2xl mx-auto bg-card rounded-xl shadow-lg p-8">
                <h2 className="text-2xl font-bold text-foreground mb-4">{isCampaign ? messages.post_campaign_title : messages.post_vacancy_title}</h2>
                <p className="text-muted-foreground text-lg">
                    {isCampaign ? messages.end_campaign_text : messages.end_vacancy_text}
                </p>
                {endDate && (
                <p className="text-sm text-muted-foreground mt-4">
                    {isCampaign ? "Campaign ended: " : "Position closed: "} {endDate.toLocaleString(undefined, {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                    })}
                </p>
                )}
                </div>
            </div>
            );
        }

        return null;
    };
    return renderCampaignPrePostText();
};

export default CampaignPrePostText;
